import React from 'react'
import { Tooltip, TooltipProps, styled } from '@mui/material'

const StyledLabel = styled('label')`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`

interface Props {
    label: string
    tooltip: TooltipProps['title']
    icon: TooltipProps['children']
}

export const LabelWithTooltipIcon: React.VFC<Props> = ({ label: labelText, tooltip, icon }: Props) => {
    return (
        <StyledLabel>
            {labelText}
            <Tooltip title={tooltip}>{icon}</Tooltip>
        </StyledLabel>
    )
}

export type { Props as LabelWithTooltipIconProps }
